import { createReducer, on } from "@ngrx/store";
import { setTransactionsStat } from "./transactionDashboard.actions";
import { AppState } from "./transactionDashboard.model";

export const initialState: AppState = {
    yesterdayT: null,
    last7dayT: null,
    lastMonthT: null
}

export const transactionDashboardReducer = createReducer(
    initialState,
    on(setTransactionsStat, (state, {transactions, isYesterday, isLastMonth}) => {
        const newState = isYesterday 
        ? { yesterdayT: transactions } : ( isLastMonth ? { lastMonthT: transactions }
        : { last7dayT: transactions } )
        return ({
            ...state,
            ...newState
        })
    })
)